module.exports = __webpack_public_path__ + "img/yy-s4.49edb3c8.svg";